import {
  Div,
  Dropdown,
  HeaderIconWrapper,
  Overlay,
  TextButton,
  ThreeDots,
  isAdmin,
  overlayAnimationVariant,
} from '@vgrubs/components';
import { useState } from 'react';

export const OrdersDropdown = ({
  handleHistoryAssign,
}: {
  handleHistoryAssign: () => void;
}) => {
  const [dropdown, setDropdown] = useState(false);

  const handleHistoryAssignClick = () => {
    setDropdown(false);
    handleHistoryAssign();
  };

  return (
    <>
      <Dropdown
        padding="16px 20px"
        isOpen={dropdown}
        toLeft
        triggerComponent={
          <HeaderIconWrapper
            $opened={dropdown}
            onClick={() => setDropdown((prev) => !prev)}
          >
            <ThreeDots />
          </HeaderIconWrapper>
        }
      >
        <Div $width="200px" $flex $column $alignStart $gap="8px" $gapSM="8px">
          {isAdmin && (
            <>
              <TextButton onClick={handleHistoryAssignClick}>
                Fleet Assign History
              </TextButton>{' '}
            </>
          )}
        </Div>
      </Dropdown>
      {dropdown && (
        <Overlay
          key="modalOverlay"
          variants={overlayAnimationVariant}
          initial="initial"
          animate="animate"
          exit="exit"
          onClick={() => setDropdown(false)}
        />
      )}
    </>
  );
};
